@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.cali.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.cali.composeapp.generated.resources/"

@delegate:ResourceContentHash(-1_482_383_060)
internal val Res.drawable.ic_burn_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_burn_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_burn_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_576_596_347)
internal val Res.drawable.ic_calendar_clock_32: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar_clock_32", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar_clock_32.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_140_060_987)
internal val Res.drawable.ic_chat_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_chat_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_chat_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(759_317_629)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-771_540_245)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-179_817_572)
internal val Res.drawable.ic_home_32: DrawableResource by lazy {
      DrawableResource("drawable:ic_home_32", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home_32.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_455_903_981)
internal val Res.drawable.ic_home_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_home_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-261_280_617)
internal val Res.drawable.ic_home_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_home_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_262_637_833)
internal val Res.drawable.ic_info_9: DrawableResource by lazy {
      DrawableResource("drawable:ic_info_9", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_info_9.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-529_714_286)
internal val Res.drawable.ic_insights_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_insights_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_insights_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_557_161_202)
internal val Res.drawable.ic_insights_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_insights_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_insights_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-448_678_580)
internal val Res.drawable.ic_motivational_phrase_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_motivational_phrase_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_motivational_phrase_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_666_012_499)
internal val Res.drawable.ic_motivational_phrase_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_motivational_phrase_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_motivational_phrase_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_806_134_996)
internal val Res.drawable.ic_notification_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_notification_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_notification_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_459_116_372)
internal val Res.drawable.ic_profile_default: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_default", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_default.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(231_097_514)
internal val Res.drawable.ic_profile_selected: DrawableResource by lazy {
      DrawableResource("drawable:ic_profile_selected", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_profile_selected.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_719_949_252)
internal val Res.drawable.ic_scroll_content_32: DrawableResource by lazy {
      DrawableResource("drawable:ic_scroll_content_32", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_scroll_content_32.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_913_497_726)
internal val Res.drawable.ic_speechbubble_32: DrawableResource by lazy {
      DrawableResource("drawable:ic_speechbubble_32", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_speechbubble_32.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-830_991_327)
internal val Res.drawable.ic_splash: DrawableResource by lazy {
      DrawableResource("drawable:ic_splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_splash.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-282_829_108)
internal val Res.drawable.ic_steps_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_steps_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_steps_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(384_649_545)
internal val Res.drawable.ic_user_32: DrawableResource by lazy {
      DrawableResource("drawable:ic_user_32", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_user_32.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(552_577_734)
internal val Res.drawable.img_log_water_footer: DrawableResource by lazy {
      DrawableResource("drawable:img_log_water_footer", setOf(
        ResourceItem(setOf(), "${MD}drawable/img_log_water_footer.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-276_151_844)
internal val Res.drawable.img_meal_plan: DrawableResource by lazy {
      DrawableResource("drawable:img_meal_plan", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_meal_plan.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_meal_plan.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_meal_plan.jpg", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_burn_24", Res.drawable.ic_burn_24)
  map.put("ic_calendar_clock_32", Res.drawable.ic_calendar_clock_32)
  map.put("ic_chat_default", Res.drawable.ic_chat_default)
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_home_32", Res.drawable.ic_home_32)
  map.put("ic_home_default", Res.drawable.ic_home_default)
  map.put("ic_home_selected", Res.drawable.ic_home_selected)
  map.put("ic_info_9", Res.drawable.ic_info_9)
  map.put("ic_insights_default", Res.drawable.ic_insights_default)
  map.put("ic_insights_selected", Res.drawable.ic_insights_selected)
  map.put("ic_motivational_phrase_default", Res.drawable.ic_motivational_phrase_default)
  map.put("ic_motivational_phrase_selected", Res.drawable.ic_motivational_phrase_selected)
  map.put("ic_notification_24", Res.drawable.ic_notification_24)
  map.put("ic_profile_default", Res.drawable.ic_profile_default)
  map.put("ic_profile_selected", Res.drawable.ic_profile_selected)
  map.put("ic_scroll_content_32", Res.drawable.ic_scroll_content_32)
  map.put("ic_speechbubble_32", Res.drawable.ic_speechbubble_32)
  map.put("ic_splash", Res.drawable.ic_splash)
  map.put("ic_steps_24", Res.drawable.ic_steps_24)
  map.put("ic_user_32", Res.drawable.ic_user_32)
  map.put("img_log_water_footer", Res.drawable.img_log_water_footer)
  map.put("img_meal_plan", Res.drawable.img_meal_plan)
}
